import type { IGuidesManager } from '@src/slide/application/service/guides-manager/index.interface';
import type { IAbsorbManager } from '@src/slide/application/service/absorb-manager/absorb-manager.interface';
import type { ISnapLineService } from '@src/slide/application/service/snap-line-service/interface/snap-line-service.interface';
import type { ISubscribableService } from '@src/slide/application/service/subscribable-service/subscribable-service.interface';
import type { IFlipInfo, ISizeInfo } from '@src/slide/application/service/edit-action-services/element-info';
import type { MODES } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import type { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiRect } from '@src/slide/application/service/edit-action-services/edit-process/edit-process.interface';

export interface IResizeEventPayload {
    elementModel: IElementBaseModel;
    e?: any;
}

export interface IResizingEventPayload extends IResizeEventPayload {
    originalSize: ISizeInfo & IFlipInfo;
    nextSize: ISizeInfo & IFlipInfo;
    mode: MODES;
    multiRect: IMultiRect | null;
    sizeMap?: any;
}


export enum ResizeEventType {
    RESIZING = 'resizing',
    RESIZE_START = 'resizeStart',
    RESIZE_STOP = 'resizeStop',
}

export interface ResizeEventMap {
    [ResizeEventType.RESIZE_START]: IResizeEventPayload;       // resize开始
    [ResizeEventType.RESIZE_STOP]: IResizeEventPayload;        // resize结束
    [ResizeEventType.RESIZING]: IResizingEventPayload;        // resize过程
}

export interface IResizeElementHandler extends ISubscribableService<ResizeEventMap>{
    handleResizeStart(elementModel: IElementBaseModel, e, scale: number, mode: string): void;
    handleResize(e, originalSize, nextSize, mode, sizeMap?): void;
    handleResizeStop(mode): void;
    handleResizeStartForRootGroup(): void;
    handleResizeForRootGroup(e, originalSize, nextSize, mode, srcRect, offsetFrame, sizeMap?): void;
    handleResizeStopForRootGroup(mode): void;
    setGuidesManagerDelegate(guidesManager: IGuidesManager): void;
    setAbsorbManagerDelegate(absorbManager?: IAbsorbManager): void;
    setSnapLineServiceDelegate(snapLineService?: ISnapLineService): void;
}
